import React, { useState, useEffect } from 'react';
import { Grid, Box } from '@mui/material';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { CustomTextField } from 'components';

const WhattoExpectField = ({ content, setContent }: any) => {
  const [expectation, setExpectation] = useState(content.expectations || '');

  // Function to strip HTML tags and get plain text
  const stripHtml = (html: string) => {
    const div = document.createElement('div');
    div.innerHTML = html;
    return div.textContent || div.innerText || '';
  };

  useEffect(() => {
    // Strip the HTML to get the meaningful content
    const strippedText = stripHtml(expectation).trim();

    // Debugging: log the stripped text to see if it's working as expected


  }, [expectation]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newExpectation = e.target.value;
    setExpectation(newExpectation);
    // Update contentData with the new title
    setContent((prevContentData: any) => ({
      ...prevContentData,
      expectations: newExpectation,
    }));

  };



  return (
    <Grid display={"flex"} gap={5} flexDirection={"column"} p={{ xs: 2, md: 5 }} mt={{ xs: 3, md: 0 }}>
      <Grid item xs={12} sm={6} display={"flex"} flexDirection={"column"}>
        <label
          htmlFor="expectations"
          style={styleSheet.labelText}
        >
          What to expect from this {content.type}
        </label>
        {/* <Grid display={"flex"} gap={2} mt={1} alignItems={"center"} flex={1}
                    width={{ xs: "333px", md: "654px" }}>
                    <Box sx={{
                        flexGrow: 1, border: '1px solid #ccc', borderRadius: '9px', overflow: 'hidden',
                    }}>
                        <ReactQuill
                            value={expectation}
                            onChange={handleChange}
                            modules={{
                                toolbar: [
                                    // ['bold', 'italic', 'underline'],
                                    // [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                                ]
                            }}
                            style={{
                                width: '100%',
                                height: '323px',
                            }}
                        />
                    </Box>
                </Grid> */}
        <Grid display={"flex"} gap={2} alignItems={"center"} flex={1}>
          <Box sx={{ flexGrow: 1 }}>
            <CustomTextField
              name="expectations"
              multiline
              rows={10}
              sx={{ width: "100%", maxWidth: "654px" }}
              value={expectation}
              onChange={handleChange}
            />

          </Box>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default WhattoExpectField;

const styleSheet = {
  labelText: {
    fontWeight: 400,
    fontSize: "17px",
    color: "#000000",
  }
};
